module.exports = __webpack_public_path__ + "static/img/0.4e5c3e71.jpg";